import { PRELOAD_MOBILE_CONFIG_VERSION } from 'index'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { isCurrentEntryHostOutdated } from 'component/EntryDomainUpdateTooltip/domain'
import actions from 'redux/action'
import { MOBILE_CONFIG_UPDATE_REASON_CONFIG, MOBILE_CONFIG_UPDATE_REASON_ENTRY_DOMAIN } from 'redux/slice/app'
import { combinedStorage } from 'utils/combinedStorage'
import { canInstallNewConfig } from 'utils/id-util/update-util'

const iOSIsInstalled = window.navigator.standalone === true

export const useMobileConfigUpdateChecker = (): void => {
  const dispatch = useDispatch()
  useEffect(() => {
    if (!process.env.REACT_APP_BUCKET_SITE_CODE || !process.env.REACT_APP_BUCKET_SITE_KEY) {
      return
    }

    // 只有在PWA的環境下才跳出安裝提示
    if (!(iOSIsInstalled || process.env.REACT_APP_TEST_DESKTOP_UPDATE)) {
      return
    }

    let aborted = false
    const checkUpdate = async () => {
      try {
        const isEntryHostOutdated = await isCurrentEntryHostOutdated()

        if (aborted) {
          return
        }

        if (isEntryHostOutdated) {
          dispatch(actions.updateMobileConfigUpdateReason(MOBILE_CONFIG_UPDATE_REASON_ENTRY_DOMAIN))
          dispatch(actions.updateShowMobileConfigUpdate(true))
          return
        }
      } catch (err) {
        console.warn('[mobile conf] skipped stale domain check', err)
      }

      if (aborted) {
        return
      }

      const res = await canInstallNewConfig(process.env.REACT_APP_PRELOAD_PATH as string)

      if (aborted) {
        return
      }

      if (!res.canInstall) {
        console.log("[mobile conf] skipped update because can't install")
        return
      }
      if (!res.forceVersion) {
        console.log('[mobile conf] skipped update because forceVersion is not set')
        return
      }
      if (!res.configVersion) {
        console.log('[mobile conf] skipped update because config has no version')
        return
      }

      const currentConfVersion = combinedStorage.getItem(PRELOAD_MOBILE_CONFIG_VERSION)

      // only check if currentConfVersion is not empty
      if (currentConfVersion) {
        if (Number(res.forceVersion) <= Number(currentConfVersion)) {
          console.log('[mobile conf] skipped update because local version is newer')
          // don't need to update
          return
        }

        if (Number(res.configVersion) === Number(currentConfVersion)) {
          console.log('[mobile conf] skipped update because local version is the same')
          // already installed
          return
        }
      } else {
        console.log("[mobile conf] don't need to compare version because local version is empty")
      }

      dispatch(actions.updateMobileConfigUpdateReason(MOBILE_CONFIG_UPDATE_REASON_CONFIG))
      dispatch(actions.updateShowMobileConfigUpdate(true))
    }

    checkUpdate()

    return () => {
      aborted = true
    }
  }, [dispatch])
}
